import { AddVendorItemAliasMutation, RetireVendorItemAliasMutation } from "~/gql/mutations/vendorItemAliases.generated";
import { GetVendorItemAliasesQuery, GetVendorItemResolutionsQuery } from "~/gql/queries/vendorItemAliases.generated";

const vendorItemAliasEndpoints = {
	AddVendorItemAlias: {
		invalidatesTags: ["VendorItemAliases"] as AddTagTypes,
		transformResponse: (res: AddVendorItemAliasMutation) => {
			return res;
		}
	},
	GetVendorItemAliases: {
		transformResponse: (res: GetVendorItemAliasesQuery) => {
			return res;
		}
	},
	GetVendorItemResolutions: {
		transformResponse: (res: GetVendorItemResolutionsQuery) => {
			return res;
		}
	},
	RetireVendorItemAlias: {
		invalidatesTags: ["VendorItemAliases"] as AddTagTypes,
		transformResponse: (res: RetireVendorItemAliasMutation) => {
			return res;
		}
	}
};

export default vendorItemAliasEndpoints;
